import styled, {keyframes} from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const shimmer = keyframes`
    0% {
        background-position: -180% 0;
    }
    100% {
        background-position: 180% 0;
    }
`

const Holder = styled.div<{ $radius?: string }>`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: ${({$radius}) => $radius ?? '0'};
`

const Img = styled.img<{
    $loaded: boolean
    $fit: string
    $position: string
    $grayscale: boolean
    $zoomOnHover: boolean
}>`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: ${({$fit}) => $fit};
    object-position: ${({$position}) => $position};
    user-select: none;
    -webkit-user-drag: none;
    opacity: ${({$loaded}) => ($loaded ? 1 : 0)};
    filter: ${({$grayscale}) => ($grayscale ? 'grayscale(100%)' : 'none')};
    transform: translateZ(0);
    transition: opacity 600ms ${({theme}) => theme.ease.out},
    filter 600ms ${({theme}) => theme.ease.out},
    transform 900ms ${({theme}) => theme.ease.out};

    ${Holder}:hover & {
        filter: none;
        transform: ${({$zoomOnHover}) => ($zoomOnHover ? 'scale(1.06)' : 'none')};
    }
`

const Placeholder = styled.div<{ $visible: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    opacity: ${({$visible}) => ($visible ? 1 : 0)};
    transition: opacity 400ms ${({theme}) => theme.ease.out};
    background-image: linear-gradient(
            100deg,
            rgba(255, 255, 255, 0.02) 20%,
            rgba(255, 255, 255, 0.07) 42%,
            rgba(255, 255, 255, 0.02) 64%
    );
    background-size: 220% 100%;
    animation: ${shimmer} 1.6s linear infinite;
`

const PlaceholderIcon = styled(FontAwesomeIcon)`
    width: 22px;
    height: 22px;
    color: rgba(255, 255, 255, 0.16);
`

export const Styled = {
    Holder,
    Img,
    Placeholder,
    PlaceholderIcon
}
